// extracted by css-extract-rspack-plugin
export default {"itemBox":"R4Report__itemBox--MKt23","description":"R4Report__description--tmqcp"};